<template>
    <div v-if="!isEditing" class="payment-method-card-new" @click="isEditing = true">
        <AddIcon />
        <p>New Card</p>
    </div>
    <div v-else class="payment-method-card-new">
        <div class="input-container">
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputMask 
                            @focus="togglePlaceholder('card-number')"
                            @blur="togglePlaceholder('card-number')"
                            id="card-number" v-model="form.card_number" mask="9999 9999 9999 9?999 999" :class="{
                                'invalid-state-input': form.errors.card_number != null
                            }"
                            :autoClear="false"
                            placeholder=""
                        />
                        <label
                            :class="{'invalid-state': form.errors.card_number}"
                            for="card-number" class="field-with-icon">
                            <p class="paragraph-default">Card Number *</p>
                        </label>

                        <LockRed class="icon" />
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.card_number">{{ form.errors.card_number }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputMask 
                            @focus="togglePlaceholder('cvv')"
                            @blur="togglePlaceholder('cvv')"
                            id="cvv" v-model="form.cc_cvv" mask="999?9" :class="{
                                'invalid-state-input': form.errors.cc_cvv != null
                            }"
                            :autoClear="false"
                            placeholder=""
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_cvv}"
                            for="card-number" class="field-with-icon">
                            <p class="paragraph-default">CVV *</p>
                        </label>

                        <LockRed class="icon" />
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_cvv">{{ form.errors.cc_cvv }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputMask 
                            @focus="togglePlaceholder('expiration-date')"
                            @blur="togglePlaceholder('expiration-date')"
                            id="expiration-date" v-model="form.cc_exp" mask="99/99" :class="{
                                'invalid-state-input': form.errors.cc_exp != null
                            }"
                            :placeholder="!placeholdersHidden.get('expiration-date') ? ' ' : ''" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_exp}"
                            for="expiration-date">
                            <p class="paragraph-default">Expiration Date (MM/YY) *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_exp">{{ form.errors.cc_exp }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            @focus="togglePlaceholder('name-on-card')"
                            @blur="togglePlaceholder('name-on-card')"
                            id="name-on-card" v-model="form.cc_name"
                            :class="{
                                'invalid-state-input': form.errors.cc_name != null,
                            }"
                            :placeholder="!placeholdersHidden.get('name-on-card') ? ' ' : ''" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_name}"
                            for="name-on-card">
                            <p class="paragraph-default">Name On Card *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_name">{{ form.errors.cc_name }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            @focus="togglePlaceholder('card-alias')"
                            @blur="togglePlaceholder('card-alias')"
                            id="card-alias" v-model="form.cc_alias"
                            :class="{
                                'invalid-state-input': form.errors.cc_alias != null,
                            }"
                            :placeholder="!placeholdersHidden.get('card-alias') ? ' ' : ''" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_alias}"
                            for="card-alias">
                            <p class="paragraph-default">Card Alias</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_alias">{{ form.errors.cc_alias }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            @focus="togglePlaceholder('card-street')"
                            @blur="togglePlaceholder('card-street')"
                            id="card-street" v-model="form.cc_street"
                            :class="{
                                'invalid-state-input': form.errors.cc_street != null,
                            }"
                            :placeholder="!placeholdersHidden.get('card-street') ? ' ' : ''" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_street}"
                            for="card-street">
                            <p class="paragraph-default">Street *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_street">{{ form.errors.cc_street }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            @focus="togglePlaceholder('card-city')"
                            @blur="togglePlaceholder('card-city')"
                            id="card-city" v-model="form.cc_city"
                            :class="{
                                'invalid-state-input': form.errors.cc_city != null,
                            }"
                            placeholder="" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_city}"
                            for="card-city">
                            <p class="paragraph-default">City {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_city">{{ form.errors.cc_city }}</p></div>
                </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div v-if="!formattedRegions" class="input-folder--input">
                        <InputText 
                            @focus="togglePlaceholder('card-state')"
                            @blur="togglePlaceholder('card-state')"
                            id="card-state" v-model="form.cc_state"
                            :class="{
                                'invalid-state-input': form.errors.cc_state != null,
                            }"
                            placeholder="" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_state}"
                            for="card-state">
                            <p class="paragraph-default">State {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <custom-select 
                        v-else
                        v-model="selectedRegion"
                        :label="`State ${requireStateCity ? '*' : ''}`"
                        name="state"
                        id="state"
                        aria-label="Enter State"
                        :options="formattedRegions"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_state">{{ form.errors.cc_state }}</p></div>
                </div>
            </div>
            <div class="input-row">
            <div class="field-state input-folder">
                    <custom-select 
                        v-model="selectedCountry"
                        label="Country *"
                        name="country"
                        id="country"
                        aria-label="Enter Country"
                        :options="formattedCountries"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_country">{{ form.errors.cc_country}}</p></div>
            </div>
            </div>
            <div class="input-row">
                <div class="field-state input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            @focus="togglePlaceholder('card-zip')"
                            @blur="togglePlaceholder('card-zip')"
                            id="card-zip" v-model="form.cc_zip"
                            :class="{
                                'invalid-state-input': form.errors.cc_zip != null,
                            }"
                            :placeholder="!placeholdersHidden.get('card-zip') ? ' ' : ''" 
                        />
                        <label
                            :class="{'invalid-state': form.errors.cc_zip}"
                            for="card-zip">
                            <p class="paragraph-default">Postal Code {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="form.errors.cc_zip">{{ form.errors.cc_zip }}</p></div>
                </div>
            </div>

        </div>
        <p class="paragraph-default invalid-state" v-if="form.errors.message">{{ form.errors.message }}</p>
        <div style="gap: 1rem; display: flex; flex-direction: row;">
            <button v-if="isEditing" :disabled="form.processing" type="button" class="primary" @click="saveCard">Save</button>
            <button v-if="isEditing" type="button" class="primary" @click="isEditing = false">Cancel</button>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, defineEmits, inject, watch } from "vue";
    import { useForm } from "@/helpers/composables/useForm";
    import { string, object} from 'yup';
    import { usePaymentMethod } from "@/helpers/composables/paymentMethod"
    import { useSettingsStore } from "@/store/settings";
    import InputMask from "primevue/inputmask";
    import InputText from "primevue/inputtext";
    import AddIcon from "@icons/add.svg";
    import LockRed from "@icons/lock-red.svg";
    import { nextTick } from "process";

    const {setNotificationMessage} = useSettingsStore();
    const emit = defineEmits(['saveCard']);
    let route = inject("route");
    let props = defineProps({
        regions: {
            type: Array<Object>,
            default: []
        },
        countries: {
            type: Array<Object>,
            default: []
        },
        user: {
            type: Object,
            default(){
                return {};
            }
        }
    });

    let isEditing = ref(false);

    const {
        createConsumerCreditCard,
        createCompanyCreditCard
    } = usePaymentMethod();

    const placeholdersHidden = ref(new Map());
    function togglePlaceholder(id) {
        if(!placeholdersHidden.value.has(id)) {
            placeholdersHidden.value.set(id, true);
        }else{
            placeholdersHidden.value.set(id, !placeholdersHidden.value.get(id));
        }
    }

    const luhnCheck = function (cardNumber) {
        cardNumber = cardNumber.replace(/\D/g, "");
        let sum = 0;
        let numDigits = cardNumber.length;
        let parity = numDigits % 2;
        for (let i = 0; i < numDigits; i++) {
            let digit = parseInt(cardNumber.charAt(i));
            if (i % 2 == parity) digit *= 2;
            if (digit > 9) digit -= 9;
            sum += digit;
        }
        return sum % 10 == 0;
    };

    function getCardType(cardNumber) {
        cardNumber = cardNumber.replace(/\D/g, "");
        const cardTypes = [
            { type: 'Visa', pattern: /^4[0-9]{12,18}$/, length: [13, 16, 19] },
            { type: 'MasterCard', pattern: /^(5[1-5][0-9]{14}|2[2-7][0-9]{14})$/, length: [16] },
            { type: 'American Express', pattern: /^3[47][0-9]{13}$/, length: [15] },
            { type: 'Discover', pattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/, length: [16] },
        ];
        for (const cardType of cardTypes) {
            if (cardType.pattern.test(cardNumber) && cardType.length.includes(cardNumber.length)) {
                return cardType.type;
            }
        }
        return 'Unknown';
    }

    const form = useForm({
        useInertia: false,
        schema: object({
            card_number: string().required('Card Number is required').test({
                name: "card_number",
                message: "Invalid card number",
                test: (value) => {
                    return props.user.is_dealer ? getCardType(value) != 'Unknown' && luhnCheck(value) : getCardType(value) != 'Unknown'  ? true : luhnCheck(value) ;
                }
            }).default(''),
            cc_cvv: string().required('CVV is required').test({
                name: "cc_cvv",
                message: "Invalid CVV",
                test: (value) => {
                    return value.length >= 3 && value.length <= 4;
                }
            }).default(''),
            cc_name: string().required('Name is required').default(''),
            cc_exp: string().required('Expiration date is required').test({
                name: "cc_exp",
                message: "Invalid expiration date",
                test: (value) => {
                    if (value) {
                        const [month, year] = value.split("/");
                        const now = new Date();
                        const exp = new Date(`20${year}`, month);
                        return exp > now && parseInt(month) > 0 && parseInt(month) < 13;
                    }
                    return false;
                }
            }).default(''),
            cc_alias: string().notRequired().default(''),

            cc_street: string().required('Street 1 is required').default(''),
            cc_city: string().optional().test(
                'is-not-empty',
                'City is required',
                (value) => {
                    if(form.cc_country == 'USA' || form.cc_country == 'CAN'){
                        return  value !== undefined && value !== '' && value !== null;
                    }
                    return true;
                }
            ).default(''),
            cc_state: string().optional().test(
                'is-not-empty',
                'State is required',
                (value) => {
                    if(form.cc_country == 'USA' || form.cc_country == 'CAN'){
                        return  value !== undefined && value !== '' && value !== null;
                    }
                    return true;
                }
            ).default(''),
            cc_zip: string().optional().test(
                'is-not-empty',
                'Postal code is required',
                (value) => {
                    if(form.cc_country == 'USA' || form.cc_country == 'CAN'){
                        return value !== undefined && value !== '' && value !== null;
                    }
                    return true;
                }
            ).default(''),
            cc_country: string().required('Country is required').default(''),
        })
    });

    const requireStateCity = computed(()=>{
        return !!form.cc_country && ['USA','CAN'].includes(form.cc_country);
    })

    let formattedCountries = computed(()=>{
        return props.countries.map((country)=>{
            return {
                value: country.name,
                key: country.alpha3code
            }
        });
    });
    let selectedCountry = computed({
        get(){
            return formattedCountries.value.find(currentCountry=>currentCountry.key == form.cc_country) ?? {key: '', value: ''};
        },
        set(value){
            form.cc_country = value.key;
        }
    });
    const CANADA_STATE_CODES = new Set(['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']);
    let formattedRegions = computed(()=>{
        const regions = props.regions ?? [];
        const countryRegionMap = {
            'CAN': regions
                .filter(region => CANADA_STATE_CODES.has(region.code) && region.code !== 'PR')
                .map(region => ({ key: region.code, value: region.name })),
            'PRI': [{ key: 'PR', value: 'Puerto Rico' }],
            'USA': regions
                .filter(region => !CANADA_STATE_CODES.has(region.code))
                .map(region => ({ key: region.code, value: region.name }))
        };
        return countryRegionMap[form.cc_country] ?? null;
    });
    let selectedRegion = computed({
        get(){
            return formattedRegions.value.find(currentRegion => currentRegion.key == form.cc_state) ?? {key: '', value: ''};
        },
        set(newVal){
            form.cc_state = newVal.key;
        }
    });
    watch(() => form.cc_country, (newCountryValue, oldCountryValue) => {
        if (!['USA', 'CAN', 'PRI'].includes(newCountryValue) && ['USA', 'CAN', 'PRI'].includes(oldCountryValue)) {
            form.cc_state = '';
            return;
        }
        if (['USA', 'CAN', 'PRI'].includes(newCountryValue)) {
            let state = form.cc_state?.toLowerCase();
            let availableStates = formattedRegions.value || [];

            let matchedState = availableStates.find(
                s => s.value?.toLowerCase() === state || s.key?.toLowerCase() === state
            );
            form.cc_state = matchedState ? matchedState.key : '';
        }
    });

    let afterAdd = computed(()=>{
        return route("account.paymentMethods");
    });

    let saveCard = () => {
        if(form.processing) return;
        
        form.validate({all: true});
        nextTick(()=>{
            if(Object.keys(form.errors).length == 0){
                let data = JSON.parse(JSON.stringify(form));
                data.card_number = data.card_number.replace(/\D/g, "");
                data.cc_type = getCardType(data.card_number);
                data.cc_last_4 = data.card_number.slice(-4);
                data.cc_exp = data.cc_exp.replace(/\D/g, "");
                if(props.user.is_dealer && !['Master Card', 'MasterCard', 'Visa'].includes(data.cc_type)){
                    setNotificationMessage({
                        type: 'error',
                        message: 'Only Visa and Master Card are accepted for dealers'
                    });
                    return;
                }
            //     form.post((props.user.is_dealer ? route("endpoints.creditcards.store") : route("endpoint.consumer_credit_cards.store")),{
            //         credit_card: {
            //             ...form.transform((data)=>({
            //                 ...data,
            //                 card_number: data.card_number.replace(/\D/g, ""),
            //                 cc_type: getCardType(data.card_number),
            //                 cc_last_4: data.card_number.slice(-4),
            //                 cc_exp: data.cc_exp.replace(/\D/g, "")
            //             }))
            //         }
            //     },{
            //         afterFetch: (ctx)=>{
            //             emit('saveCard', ctx.data);
            //             form.card_number = '';
            //             form.cc_name = '';
            //             form.cc_exp = '';
            //             form.cc_alias = '';
            //             form.cc_street = '';
            //             form.cc_city = '';
            //             form.cc_state = '';
            //             form.cc_zip = '';
            //             form.cc_country = '';
            //             isEditing.value = false;
            //         }
            //     }
            // )
            // }
            form.post((props.user.is_dealer ? route("endpoints.creditcards.store") : route("endpoint.consumer_credit_cards.store")),{
                credit_card: {
                    ...form.transform((data)=>({
                        ...data,
                        card_number: data.card_number.replace(/\D/g, ""),
                        cc_type: getCardType(data.card_number),
                        cc_last_4: data.card_number.slice(-4),
                        cc_exp: data.cc_exp.replace(/\D/g, "")
                    }))
                }
            },{
                onFetchError: (ctx)=>{
                    setNotificationMessage({
                        type: "error",
                        message: "An error occurred while trying to add this card. Please try again."
                    });
                },
                afterFetch: (ctx)=>{
                    emit('saveCard', ctx.data);
                    form.card_number = '';
                    form.cc_name = '';
                    form.cc_exp = '';
                    form.cc_alias = '';
                    form.cc_street = '';
                    form.cc_city = '';
                    form.cc_state = '';
                    form.cc_zip = '';
                    form.cc_cvv = '';
                    form.cc_country = '';
                    isEditing.value = false;
                    setNotificationMessage({
                        type: "success",
                        message: "Card added successfully"
                    });
                }
            })
        }
        });
    };
</script>